import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { dimGrey, lightBlack, lightPurple } from '../../../mainTheme';

interface BaseCardProps {
  title: string;
  isSelected?: boolean;
  onClick?: () => void;
  comingSoon?: boolean;
  children?: React.ReactNode;
  totalCount?: string;
  icon?: React.ReactElement;
}

const BaseCard: React.FC<BaseCardProps> = ({
  title,
  isSelected,
  onClick,
  comingSoon,
  children,
  totalCount,
  icon,
}) => (
  <Paper
    elevation={isSelected ? 8 : 1}
    sx={{
      px: '24px',
      py: '21px',
      cursor: 'pointer',
      transition: 'all 0.3s',
      transform: isSelected ? 'scale(1.02)' : 'none',
      '&:hover': {
        elevation: 3,
      },
      borderRadius: '8px',
      border: isSelected
        ? `1px solid ${lightPurple}`
        : '1px solid var(--Outline-O5---Separator, #D4D4D9)',
      boxShadow: isSelected ? '-4px 8px 24px 0px rgba(0, 0, 0, 0.25)' : 'none',
      height: '152px',
      flex: '1 0 0',
      overflow: 'hidden',
    }}
    onClick={onClick}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        mb: '8px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography
          sx={{
            color: isSelected ? lightBlack : dimGrey,
            fontSize: '16px',
            fontWeight: 700,
            letterSpacing: '0.2px',
            mr: '6px',
          }}
        >
          {title}
        </Typography>
        {icon &&
          React.cloneElement(icon, {
            style: { color: isSelected ? lightPurple : undefined },
          })}
      </Box>
      <Typography
        sx={{
          color: isSelected ? lightBlack : dimGrey,
          fontSize: '16px',
          fontWeight: 700,
          letterSpacing: '0.2px',
        }}
      >
        {totalCount}
      </Typography>
      {comingSoon && (
        <Box>
          <Typography
            sx={{
              color: lightBlack,
              fontSize: '16px',
              fontWeight: 700,
              lineHeight: '22px',
            }}
            textAlign="right"
          >
            Coming soon
          </Typography>
          <Typography
            sx={{
              color: dimGrey,
              fontSize: '14px',
              fontWeight: 500,
              lineHeight: '20px',
            }}
          >
            Check back for updates!
          </Typography>
        </Box>
      )}
    </Box>

    {!comingSoon && ( // For temporary use
      <Box sx={{ overflow: 'hidden' }}>{children}</Box>
    )}
  </Paper>
);

export default BaseCard;
